import React from 'react';
import classNames from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import Button from '@/components/button';
import styles from './index.module.scss';

const HasSubmit: React.FC<Record<string, null>> = () => {
  return (
    <section className={styles.HasSubmit}>
      <img
        className={styles.headerImg}
        src="https://assets-oss.cbndata.com/cbndata-refactor-fe/Fh0xSZ2BNzILM9Be3QtHNU6WU8rT.png"
      />
      <div className={styles.headerTitle}>您已提交过入驻申请!</div>
      <div className={styles.headerSubTitle}>预计2-4个工作日产品信息审核通过后，将会同步官网展示。</div>
      <div className={classNames('flex-row-nowrap', 'flex-between-center', styles.operationBtn)}>
        <CopyToClipboard text="cbndatacs@yinfinity.com" onCopy={() => toast.success('复制成功')}>
          <Button width={140}>点击复制官方邮箱</Button>
        </CopyToClipboard>
        <Button width={140}>
          <a
            download="产品模板"
            href="https://assets-v2.cbndata.com/material_resources/%E4%BA%A7%E5%93%81%E6%A8%A1%E7%89%88.xlsx"
            style={{ color: '#fff' }}
          >
            点击下载产品模板
          </a>
        </Button>
      </div>
    </section>
  );
};
export default HasSubmit;
